import React, { useEffect } from 'react'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';

const SchoolRecordLayout = () => {

    const navigate = useNavigate();
    const location = useLocation()
    const pathname = location.pathname

    //   useEffect(() => {
    //     if (pathname === '/survey') navigate('/survey/form');
    //   }, [navigate]);

    //   const menuItems = [
    //     { path: '/survey/form', label: '상담 신청서 작성' }, 
    //     { path: '/survey/test', label: 'SLT/MCI 검사' },
    //     { path: '/survey/report', label: '보고서 확인' },
    //   ];

    return (
        <div>
            <div className='title mb-5'>
                <h2 className='h2'>KGS 생활기록부</h2>
            </div>

            {/* 서브메뉴 */}
            {/*
            <div className='wrap-submenu pb-5'>
                <ul className='submenu'>
                {menuItems.map((item) => (
                    <li key={'submenu-item-' + item.path} className={`submenu__item`} >
                    <NavLink to={item.path} className="submenu__link">{item.label}</NavLink>
                    </li>
                ))}
                </ul> 
            </div>
            */}

            <div className='content'>
                <Outlet />
            </div>
        </div>
    )
}

export default SchoolRecordLayout